module.exports = __webpack_public_path__ + "73f63c410fd70f0b1faa24ffab2706da.png";